/* eslint-disable react/no-danger */
import React, { useState } from "react";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// ANT DESIGN COMPONENTS
import { Button, Tooltip } from "antd";
// FONT AWESOME LIBRARY AND ICONS
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
// COMPONENTS
import FormInputText from "../../../../../components/form/FormInputText";
// INTERFACES
import { GetNamesResponseInterface } from "../../../../../../interfaces/AdapterCdoOpc.interface";

export default function ComponentGetNamesResponse({
  data,
  setData,
}: {
  data: GetNamesResponseInterface;
  setData: (newValue: GetNamesResponseInterface) => void;
}) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const [t] = useTranslation("global");

  // ************************************************ */
  // USE STATE VARIABLES **************************** */
  const [name, setName] = useState<string>("");

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */

  // ************************************************ */
  // CUSTOM HOOKS *********************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const onChangeDataValueString = (newValue: string) => {
    setName(newValue);
  };

  const formatJsonWithColors = (obj: any) => {
    const json = JSON.stringify(obj, null, 4)
      .replace(/"([^"]+)"\s*:/g, '<span style="color:#9cdcfe;">"$1"</span>:')
      .replace(/: "([^"]*)"/g, ': <span style="color:#ce9178;">"$1"</span>')
      .replace(/:\s*(\d+)/g, ': <span style="color:#b5cea8;">$1</span>');
    return json;
  };

  const onClickRemoveItem = (index: number) => {
    const copy = structuredClone(data);
    copy.names.splice(index, 1);
    setData(copy);
  };

  const onClickAddNewValue = () => {
    const copy = structuredClone(data);
    copy.names.push(name);
    setName("");
    setData(copy);
  };

  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div>
      <FormInputText
        inputValue={name}
        inputLabelName={t("general.name")}
        inputOnChange={onChangeDataValueString}
        inputVariableName=""
        isRequired
        disabledInput={false}
      />
      <div className="col-md-12 mt-3">
        <div className="generalStyles__flex">
          <div className="generalStyles__inputFlexNameLarge">
            <span className="generalStyles__inputFlexRequired">*</span>
            <span className="drawer__text">{t("general.nameList")}</span>
          </div>
          <div className="generalStyles__width100">
            {data.names.map((item: string, itemIndex: number) => (
              <div
                key={itemIndex}
                className="mb-3"
                style={{
                  backgroundColor: "#1f1f1f",
                  borderRadius: "5px",
                  fontSize: "9px",
                  padding: "10px",
                }}
              >
                <div
                  style={{
                    width: "100%",
                  }}
                >
                  <pre
                    style={{
                      width: "100%",
                      color: "#dcdcdc",
                      padding: "10px",
                      borderRadius: "8px",
                      overflowX: "auto",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: formatJsonWithColors(item),
                    }}
                  />
                  <div className="generalStyles__flexCenter">
                    <Tooltip title={t("general.delete")}>
                      <Button
                        onClick={() => {
                          onClickRemoveItem(itemIndex);
                        }}
                        className="buttonStyle__29"
                        shape="circle"
                        icon={<FontAwesomeIcon icon={faTrash} />}
                      />
                    </Tooltip>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="generalStyles__infoTooltipIconBlank" />
        </div>
      </div>
      <div className="col-md-12 mt-3">
        <div className="generalStyles__flex">
          <div className="generalStyles__inputFlexNameLarge">
            <span className="generalStyles__inputFlexRequired" />
          </div>
          <div className="generalStyles__width100">
            <Button
              onClick={onClickAddNewValue}
              className="buttonStyle__28 generalStyles__width100"
            >
              <FontAwesomeIcon icon={faPlus} className="generalStyles__mrFix" />
              {t("general.add")}
            </Button>
          </div>
          <div className="generalStyles__infoTooltipIconBlank" />
        </div>
      </div>
    </div>
  );
}
